import { Section } from '../models/section';

export const SECTIONS: Section[] = [
  { slug: 'arqueologia', name: 'Arqueología' },
  { slug: 'artes-populares', name: 'Artes populares' },
  { slug: 'artes-visuales', name: 'Artes visuales' },
  { slug: 'danza', name: 'Danza' },
  { slug: 'diseno-y-arquitectura', name: 'Diseño y arquitectura' },
  { slug: 'historia', name: 'Historia' },
  { slug: 'instituciones-y-recintos-culturales', name: 'Instituciones y recintos culturales' },
  { slug: 'literatura', name: 'Literatura' },
  { slug: 'musica-y-opera', name: 'Música y ópera' },
  { slug: 'personajes', name: 'Personajes' },
  { slug: 'Teatro', name: 'Teatro' },
];
